exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".age-legend .ringworm{display:inline-block;background:#f7402d;border-radius:4px;margin-bottom:14px;width:40px;color:#fff;line-height:32px;text-align:center}.age-legend span{display:inline-block;width:40px;margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ac9cae5c","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Board/AgeLegend.vue
// module id = 420
// module chunks = 0